import React, { useEffect, useState } from 'react';
import FirebaseCalendar from '../pages/dashboard/calendar/FirebaseCalendar';

interface CalendarModalProps {
    onClose: () => void;
}

const CalendarModal: React.FC<CalendarModalProps> = ({ onClose }) => {
    const [showModal, setShowModal] = useState(true);

    const handleClose = () => {
        setShowModal(false);
        onClose();
    };

    // Esc closes, same as every other overlay in the app (AgentAccessModal, Andrei chat,
    // the email views). Without it the only escape hatch on a phone was the ~10px dialog
    // margin, which sits inside the OS back-swipe zone — effectively a trap.
    useEffect(() => {
        const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') handleClose(); };
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleBackdropClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) {
            handleClose();
        }
    };

    return (
        <>
        {showModal && (
            <div
                className="modal d-block calendar-modal"
                style={{ zIndex: 1055 }}
                tabIndex={-1}
                role="dialog"
                aria-modal="true"
                aria-label="Calendar"
                onClick={handleBackdropClick}
            >
                <div
                    className="modal-dialog modal-xl"
                    style={{
                        maxWidth: '95vw',
                        width: '95vw',
                        // Dynamic viewport units: index.html opts into viewport-fit=cover and iOS
                        // resolves `vh` against the LARGE viewport, so 95vh overhung the visible
                        // area. dvh tracks the browser chrome; the env() insets keep the dialog
                        // clear of the notch and the home indicator.
                        height: '95dvh',
                        maxHeight: '95dvh',
                        minHeight: 0,
                        margin: '2.5dvh auto',
                        paddingTop: 'env(safe-area-inset-top)',
                        paddingBottom: 'env(safe-area-inset-bottom)',
                        paddingLeft: 'env(safe-area-inset-left)',
                        paddingRight: 'env(safe-area-inset-right)',
                        display: 'flex'
                    }}
                >
                    <div
                        className="modal-content h-100"
                        style={{
                            backgroundColor: 'var(--bs-body-bg)',
                            borderColor: 'var(--bs-border-color)',
                            borderRadius: '0.75rem',
                            border: '1px solid var(--bs-border-color)',
                            boxShadow: 'var(--bs-dropdown-box-shadow)',
                            display: 'flex',
                            flexDirection: 'column'
                        }}
                    >
                        <div className="modal-header">
                            <h5 className="modal-title">Calendar</h5>
                            <button
                                type="button"
                                className="btn-close"
                                aria-label="Close"
                                onClick={handleClose}
                                // 44px is the minimum comfortable thumb target on a phone; the
                                // default btn-close is roughly half that.
                                style={{ width: '44px', height: '44px' }}
                            ></button>
                        </div>
                        <div
                            className="modal-body p-0 h-100"
                            style={{
                                flex: 1,
                                minHeight: 0,
                                overflow: 'hidden',
                                backgroundColor: 'var(--bs-body-bg)'
                            }}
                        >
                            <FirebaseCalendar />
                        </div>
                    </div>
                </div>
            </div>
        )}
        {/* Single scrim: the inline rgba(0,0,0,0.5) on the modal used to stack with this
            backdrop for ~75% black. The .modal-backdrop element is the themeable one, so it stays. */}
        {showModal && <div className="modal-backdrop fade show"></div>}
        </>
    );
};

export default CalendarModal;
